import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields`: `settings.age_verification`. */
export const editAgeVerification = async (age_verification: string): Promise<any> =>
  writeSettingsFields({ age_verification });
